'use strict';
const Ajax = require('common/infra/ajax');

class API {
    getToken() {
        return Ajax.GET('/api/my/token/firebase');
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./common/infra/api/firebase.js